import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, TextField, Typography, makeStyles } from "@material-ui/core";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
	root: {
		display: "flex",
		flexDirection: "column",
		gap: theme.spacing(0.5),
		marginTop: theme.spacing(1),
		minWidth: 180,
	},
	row: {
		display: "flex",
		gap: theme.spacing(0.5),
		alignItems: "center",
		flexWrap: "wrap",
	},
	input: {
		width: 72,
	},
}));

const BridgeKeepAwakeConfig = ({
	whatsAppId,
	initialMinutes = 0,
	disabled = false,
}) => {
	const classes = useStyles();
	const [minutes, setMinutes] = useState(String(initialMinutes || 0));
	const [savedMinutes, setSavedMinutes] = useState(Number(initialMinutes) || 0);
	const [saving, setSaving] = useState(false);

	useEffect(() => {
		const value = Number(initialMinutes) || 0;
		setMinutes(String(value));
		setSavedMinutes(value);
	}, [initialMinutes]);

	const handleSave = async () => {
		const parsed = Number(minutes);
		if (!Number.isFinite(parsed) || parsed < 0) {
			toast.error(i18n.t("connections.bridge.keepAwakeInvalid"));
			return;
		}

		setSaving(true);
		try {
			await api.put(`/android-bridge/keep-awake/${whatsAppId}`, {
				keepAwakeMinutes: Math.floor(parsed),
			});
			setSavedMinutes(Math.floor(parsed));
			toast.success(i18n.t("connections.bridge.keepAwakeSaved"));
		} catch (err) {
			toastError(err);
		} finally {
			setSaving(false);
		}
	};

	return (
		<div className={classes.root}>
			<Typography variant="caption" color="textSecondary">
				{i18n.t("connections.bridge.keepAwakeTitle")}
			</Typography>
			<div className={classes.row}>
				<TextField
					size="small"
					variant="outlined"
					type="number"
					inputProps={{ min: 0, step: 1 }}
					className={classes.input}
					value={minutes}
					disabled={disabled || saving}
					onChange={event => setMinutes(event.target.value)}
					label={i18n.t("connections.bridge.keepAwakeMinutes")}
				/>
				<Button
					size="small"
					variant="outlined"
					color="primary"
					disabled={disabled || saving}
					onClick={handleSave}
				>
					{i18n.t("connections.bridge.keepAwakeSave")}
				</Button>
			</div>
			<Typography variant="caption" color="textSecondary">
				{savedMinutes > 0
					? i18n.t("connections.bridge.keepAwakeActive", {
							minutes: savedMinutes,
					  })
					: i18n.t("connections.bridge.keepAwakeOff")}
			</Typography>
		</div>
	);
};

export default BridgeKeepAwakeConfig;
